import connector from "@/repository/connector";

function isFormDataPayload(payload) {
  return typeof FormData !== "undefined" && payload instanceof FormData;
}

function resolveConnector(payload) {
  return isFormDataPayload(payload) ? connector.connectorFormData : connector.connector;
}

export default {
  async list(params = {}) {
    return connector.requestWithFallback(
      () => connector.connector.get("users/", { params }),
    );
  },
  async create(payload) {
    return connector.requestWithFallback(
      () => resolveConnector(payload).post("users/", payload),
    );
  },
  async me() {
    try {
      return await connector.requestWithFallback(
        () => connector.connector.get("users/me/"),
      );
    } catch (error) {
      if (error?.status === 403) {
        connector.triggerUnauthorized();
      }
      throw error;
    }
  },
  async get(userId) {
    return connector.requestWithFallback(
      () => connector.connector.get(`users/${userId}/`),
    );
  },
  async replace(userId, payload) {
    return connector.requestWithFallback(
      () => resolveConnector(payload).put(`users/${userId}/`, payload),
    );
  },
  async update(uid, payload) {
    const value = uid != null && uid !== "" ? String(uid).trim() : "";
    if (!value) {
      return Promise.reject(new Error("User uid is required for update"));
    }
    return connector.requestWithFallback(
      () => resolveConnector(payload).patch(`users/${value}/`, payload),
    );
  },
  async remove(userId) {
    return connector.requestWithFallback(
      () => connector.connector.delete(`users/${userId}/`),
    );
  },
  async deleteAccount(uid) {
    const value = uid != null && uid !== "" ? String(uid).trim() : "";
    if (!value) {
      return Promise.reject(new Error("User uid is required for delete"));
    }
    return connector.requestWithFallback(
      () => connector.connector.delete(`users/${value}/`),
    );
  },
  async changePassword(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("users/change_password/", payload),
    );
  },
  async generateWidgetToken() {
    return connector.requestWithFallback(
      () => connector.connector.post("users/generate_widget_token/", {}),
    );
  },
  async restore(payload) {
    return connector.requestWithFallback(
      () => connector.connector.post("users/restore/", payload),
    );
  },
  async stats() {
    return connector.requestWithFallback(
      () => connector.connector.get("users/stats/"),
    );
  },
  async unlinkSocialAccount(payload) {
    return connector.requestWithFallback(() =>
      connector.connector.post("users/unlink_social_account/", payload),
    );
  },
};
